import { Cell } from 'bold-ui'

import AtestadoModel, { AtestadoModeloEnum, AtestadoSelectModel, CidadaoAtestado } from './components/model-atestado'
import { AtestadoEmBrancoForm } from './em-branco/AtestadoEmBrancoForm'
import { LicencaMaternidadeForm } from './licenca-maternidade/LicencaMaternidadeForm'
import { AtestadoModeloPrescricaoView } from './modelo/AtestadoModeloPrescricaoView'
import { AtestadoPadraoForm } from './padrao/AtestadoPadraoForm'
import { SolicitacaoFraldasGeriatricasForm } from './solicitacao-fraldas-geriatricas/SolicitacaoFraldasGeriatricasForm'

interface AtestadoCadastroFormRouterProps {
  atendimentoId: ID
  prontuarioId: ID
  atestadoModelo: AtestadoSelectModel | null
  cidadao: CidadaoAtestado
  dataAtendimento: Instant
  onDeleteModelo: () => void
  onUpdateModelo: (nomeModelo: string) => void
  onSubmit: (values: AtestadoModel) => void
}

export function AtestadoCadastroFormRouter(props: Readonly<AtestadoCadastroFormRouterProps>) {
  const {
    atendimentoId,
    prontuarioId,
    atestadoModelo,
    cidadao,
    dataAtendimento,
    onDeleteModelo,
    onUpdateModelo,
    onSubmit,
  } = props

  const commonProps = {
    atendimentoId,
    prontuarioId,
    dataAtendimento,
    onSubmit,
  }

  switch (atestadoModelo?.tipo) {
    case AtestadoModeloEnum.PADRAO:
      return <AtestadoPadraoForm {...commonProps} cidadao={cidadao} />

    case AtestadoModeloEnum.EM_BRANCO:
      return (
        <Cell size={12}>
          <AtestadoEmBrancoForm {...commonProps} cidadaoId={cidadao.id} />
        </Cell>
      )

    case AtestadoModeloEnum.LICENCA_MATERNIDADE:
      return <LicencaMaternidadeForm {...commonProps} cidadao={cidadao} />

    case AtestadoModeloEnum.SOLICITACAO_FRALDAS_GERIATRICAS:
      return <SolicitacaoFraldasGeriatricasForm {...commonProps} cidadao={cidadao} />

    case AtestadoModeloEnum.PERSONALIZADO:
      return (
        <AtestadoModeloPrescricaoView
          {...commonProps}
          cidadao={cidadao}
          modeloId={atestadoModelo.id}
          onDelete={onDeleteModelo}
          onUpdate={onUpdateModelo}
        />
      )

    default:
      return null
  }
}
